import IReportFilterCriteria from "../../../../shared/contracts/IReportFilterCriteria";
import IReportSaveDataContext from "../../../../shared/contracts/IReportSaveDataContext";
import IReportSelectedColumn from "../../../../shared/contracts/IReportSelectedColumn";

export interface IReportSaveData {
  reportName: string;
  owner: string;
  reportDataSourceName : string | undefined;
  bucket: string;
  category: string;
  reportDescription: string;
  permissions: string;
  emailRecipients: string;
  exportData: string;
  reportSpecification: {
    filterCriterias: IReportFilterCriteria[] | [];
    columnSelections: IReportSelectedColumn[] | [];
  },
}

class CreateReportService {
  static getSaveReportDetailsBody = (
    createReportForm: IReportSaveDataContext,

  ): IReportSaveData => {


    const PRIVATE_ROLE = "Private";
    const PUBLIC_ROLE = "Public";
    const EVERYONE_OWNER = "Everyone";

    const body : IReportSaveData= {
      reportName: createReportForm.reportName,
      category: createReportForm.category,
      reportDescription: createReportForm.reportDescription,
      permissions: createReportForm.permissions,
      emailRecipients: createReportForm.emailRecipients,
      exportData: createReportForm.exportData,
      reportSpecification: createReportForm.reportSpecification,
      reportDataSourceName: createReportForm?.selectedDataSource?.dataSourceViewName,
      bucket: createReportForm.permissions === PRIVATE_ROLE ? PRIVATE_ROLE : PUBLIC_ROLE,
      owner: EVERYONE_OWNER,
    };

    return body;
  };
}

export default CreateReportService;